import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useIsParentViewingChild } from '../../hooks/usePortalStudentId';
import { useParentChild } from '../../context/ParentChildContext';
import ParentChildSwitcher from './ParentChildSwitcher';

/** Compact bar on child data pages when a parent is viewing a linked student. */
const ParentPortalHeader = () => {
    const { t } = useTranslation();
    const isParent = useIsParentViewingChild();
    const { selectedChild, approvedChildren } = useParentChild();

    if (!isParent) return null;

    return (
        <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-sm">
            <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 min-w-0">
                <Link
                    to="/parent"
                    className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-slate-800 shrink-0"
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                    {t('parent.parentHome')}
                </Link>
                {selectedChild && (
                    <div className="hidden sm:block h-4 w-px bg-gray-200" aria-hidden="true" />
                )}
                {selectedChild && (
                    <p className="text-sm text-gray-700 truncate">
                        <span className="text-gray-500">{t('parent.viewingPrefix')} </span>
                        <span className="font-semibold text-gray-900">{selectedChild.studentName}</span>
                    </p>
                )}
            </div>
            <div className="flex items-center gap-3 sm:shrink-0">
                {approvedChildren.length > 1 && <ParentChildSwitcher className="mb-0" />}
                <span className="hidden sm:inline text-xs text-gray-400">{t('parent.readOnly')}</span>
            </div>
        </div>
    );
};

export default ParentPortalHeader;
